import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const SuggestionsSectionHeader = /*#__PURE__*/ memo((param)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: "".concat(tailwindMerge("mb-2 mt-24 h-5 px-1.5 font-bold uppercase text-grey-9", className)),
        ...props
    });
});
SuggestionsSectionHeader.displayName = "SuggestionsSectionHeader";
